import api from "./api.js";

export default class BaseApi {
  static async Get(data) {
    return await api.get(`baseInfo`, data);
  }  
}
